// extracted by mini-css-extract-plugin
module.exports = {"outer":"outer___35Tic","who":"who___ql5cO","name":"name___bMt5r"};